import { Helper } from '@/mixin/helper'
import store from '@/state/store'

export default [
    // Notifikasi Home Page
    {
        path: '/notification/',
        name: 'Notifikasi',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.n1.read) {
                    next()
                } else {
                    next({ name: 'Liveview' })
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "notification" */ '@/router/views/notification')
    },

    // Perilaku Pengemudi Notifikasi
    {
        path: '/notification/driverbehavior/',
        name: 'Perilaku Pengemudi',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.n1.read) {
                    next()
                } else {
                    next({ name: 'Notifikasi' })
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "notification" */ '@/router/views/notification/driverbehavior')
    },

    // Perilaku Pengemudi Notifikasi Detail
    {
        path: '/notification/driverbehavior/map',
        name: 'Perilaku Pengemudi Detail',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.n1.read) {
                    next()
                } else {
                    next({ name: "Notifikasi" });
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "notification" */ '@/router/views/notification/driverbehavior/detailmap')
    },

    // Driver Monitoring System Notifikasi
    {
        path: '/notification/drivermonitoringsystem/',
        name: 'Driver Monitoring System',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.n1.read) {
                    next();
                } else {
                    next({ name: "Notifikasi" });
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "notification" */ '@/router/views/notification/drivermonitoringsystem')
    },

    // Perilaku Pengemudi Notifikasi Detail
    {
        path: '/notification/drivermonitoringsystem/map/:id',
        name: 'Driver Monitoring System Detail',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.n1.read) {
                    next();
                } else {
                    next({ name: "Notifikasi" });
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "notification" */ '@/router/views/notification/drivermonitoringsystem/detailmap')
    },

    // Umum Notifikasi
    {
        path: '/notification/general/',
        name: 'General',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.n1.read) {
                    next()
                } else {
                    next({ name: "Notifikasi" });
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "notification" */ '@/router/views/notification/general')
    },

    // Umum Notifikasi
    {
        path: '/notification/general/',
        name: 'General Detail',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.n1.read) {
                    next()
                } else {
                    next({ name: "Notifikasi" });
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "notification" */ '@/router/views/notification/general/detailmap')
    },

    // Notifikasi Setting
    {
        path: '/notification/setting/',
        name: 'Notification Setting',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.n1['n1-nc1'].read) {
                    next();
                } else {
                    next({ name: "Notifikasi" });
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "notification" */ '@/router/views/notification/notificationsetting')
    },

    // Notifikasi Fleet Group Setting
    {
        path: '/notification/notificationsetting/fleetgroupsetting',
        name: 'Notification Fleet Group Setting',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.n1.read) {
                    next()
                } else {
                    next({ name: "Notifikasi" });
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "notification" */ '@/router/views/notification/notificationsetting/fleetgroupsetting')
    },
]